import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
    carousel: {
        aspectRatio: "16 / 9",
        maxWidth: "80%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
        outline: "none",
        overflowX: "hidden",
    },
    carouselHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 0 10px 5%",
    },
    carouselHeaderSection: {
        display: "flex",
        alignItems: "center",
    },
    close: {
        color: theme.palette.primary.contrastText,
    },
    icon: {
        marginRight: 10,
    },
    dateTime: {
        marginRight: 10,
    },
    viewer: {
        display: "flex",
        flex: "1 1",
        justifyContent: "space-between",
        minHeight: 0,
    },
    fullImage: {
        objectFit: "scale-down",
        minWidth: 0,
        height: "100%",
        width: "100%",
    },
    thumbnailTrack: {
        display: "flex",
        transitionDuration: "1s",
    },
    thumbnail: {
        height: 78,
        width: 140,
        margin: "6px 2px",
        "& img": {
            height: 78,
            width: 140,
            objectFit: "contain",
            cursor: "pointer",
        },
    },
    arrow: {
        display: "flex",
        alignItems: "center",
        width: "10%",
        color: theme.palette.primary.contrastText,
    },
    highlighted: {
        outline: `5px solid ${theme.palette.info.main}`,
        outlineOffset: -5,
    },
}));
